import React from 'react';
import { Link } from 'react-router-dom';

import '../../home/home.css';

const Service = () => {

    return(
        <>
            <section className="insidePage" style={{ backgroundColor: '#2fb8e7' }}>
                <div className="container" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0.9s">
                    <p className="text-white">
                        <span className='title text-center'>Service</span> 
                        <span className='text-center subTitle'>
                            Trusted by big one and loved by everyone
                        </span>
                    </p>            
                </div>
            </section>

            <main className="main">
                <section id="clients" className="clients">
                    <div className="container" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="0.9s">
                        <div className="row gy-4">
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/web-application'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-web application.webp" alt="" />
                                    </div> 
                                    <h5>Web Application</h5>
                                    <p>Don’t leave an idea in the pipeline for long, let’s convert the idea to a web application.</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/software-development'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-software-development.webp" alt="" />
                                    </div> 
                                    <h5>SoftWare Development</h5>
                                    <p>We have been developing a small software solution to ERP. Nothing is too small or too big.</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/mobile-application'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-mobileapp.webp" alt="" />
                                    </div> 
                                    <h5>Mobile Application</h5>
                                    <p>You have an idea to make a mobile app & not sure How to develop it. Don’t worry We...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/creative'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-creative.webp" alt="" />
                                    </div> 
                                    <h5>Creative</h5>
                                    <p>We have a dedicated creative team to produce your website, logo, brochure, UX & UI...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/digital-marketing-and-seo'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-digital-marketing.webp" alt="" />
                                    </div> 
                                    <h5>Digital Marketing</h5>
                                    <p>We do creative, visual, & data-driven digital marketing to drive your sales & profit...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/domain-and-hosting'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-cloud-hosting.webp" alt="" />
                                    </div> 
                                    <h5>Domain & Hosting</h5>
                                    <p>You need the best and most secure server to host your solution on cloud across...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/consultancy'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/solution/BusinessTransformation.jpg" alt="" />
                                    </div> 
                                    <h5>Consultancy</h5>
                                    <p>We help businesses with their  IT strategies and implementation process…</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    ); 
}
export default Service;